import { DisplayElement, filterDisplayElementHideCondition } from '@urbanx/agx-ui-components';
import { CampaignDetailModel, FormPage } from '@urbanx/agx.campaigns.client';
import { AgxPanel, AgxSpacer } from '@urbanx/agx.ui-components2';
import slugify from 'slugify';
import { FormValue, FormValueType } from 'types/formConfig';
import elementRenderer from 'utils/elementRenderer';

interface PanelElementRendererProps {
  panel: FormPage;
  formValues: FormValue;
  getAuthToken: () => Promise<string>;
  onChange: (change: { id: string; value: FormValueType[keyof FormValueType] }) => void;
  campaign: CampaignDetailModel;
  validate: boolean;
}

const PanelElementRenderer = ({
  panel,
  formValues,
  getAuthToken,
  onChange,
  campaign,
  validate,
}: PanelElementRendererProps) => {
  const slugifiedPanelName = slugify(panel.name ?? '');

  const elements = filterDisplayElementHideCondition(
    (panel?.elements ?? []) as unknown as DisplayElement[],
    formValues
  );

  const renderedElements =
    panel.elements &&
    elementRenderer({
      elements: elements,
      onChange,
      campaign,
      getAuthToken,
      formValues,
      validate,
    });

  if (panel.hideFormPageName) {
    return (
      <AgxSpacer direction="vertical" gap="lg" key={slugifiedPanelName} id={slugifiedPanelName}>
        {renderedElements}
      </AgxSpacer>
    );
  }

  return (
    <AgxPanel key={slugifiedPanelName} id={slugifiedPanelName} header={panel.name}>
      {renderedElements}
    </AgxPanel>
  );
};

export default PanelElementRenderer;
